// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");

let Types = {};

let fragmentConverter = {"__root":{"":{"f":""}}};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, undefined, undefined);
}

let Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: undefined,
  convertFragment: convertFragment
};

function matchStateV5_decode($$enum) {
  if ($$enum === "INITIAL" || $$enum === "SUCCESSIVE" || $$enum === "NEW" || $$enum === "NEW_BROADCAST") {
    return $$enum;
  }
}

let matchStateV5_fromString = matchStateV5_decode;

let Utils = {
  matchStateV5_decode: matchStateV5_decode,
  matchStateV5_fromString: matchStateV5_fromString
};

let node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "QuietPropertyMatchPopup_matchForBuyerNeedV5",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "state",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ToggleMatchDismissButton_matchV5"
    }
  ],
  "type": "MatchForBuyerNeedV5",
  "abstractKey": null
};

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* RescriptRelay Not a pure module */
